/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { components } from '@seaoil/component-lib';
import {
  Typography, Progress, Row, Col,
} from 'antd';
import { LayoutWithNav } from '../../components/Layout';
import updateTask from './updateTask';

const { Text } = Typography;
const { Auth } = components;

// Statuses
const INITIALIZING = 'INITIALIZING';
const UPDATING = 'UPDATING';
const COMPLETE = 'COMPLETE';
const ERROR = 'ERROR';

function Respond(props) {
  const {
    config: {
      action = '',
      taskId = '',
      remarks = '',
      attachment = [],
    },
  } = props;

  const AuthContext = Auth.useContext();

  const [state, setState] = useState({
    message: 'Brewering...',
    status: INITIALIZING,
  });

  const data = {
    task_id: taskId,
    response: {
      action,
      remarks,
      attachment,
    },
  };

  if (state.status === INITIALIZING
    && state.status !== ERROR
    && AuthContext.status === 'LOGGED_IN') {
    setState({
      message: 'Submitting your action... Please wait.',
      status: UPDATING,
    });
    updateTask({ data })
      .then((result = {}) => {
        const { exception } = result;
        if (!exception) {
          setState({
            message: 'Task has been updated.',
            status: COMPLETE,
          });
        } else {
          setState({
            message: exception,
            status: ERROR,
          });
        }
      });
  }

  if (state.status === INITIALIZING
    && (!taskId || !action)) {
    setState({
      message: 'Sorry, looks like there\'s no request to process.',
      status: ERROR,
    });
  }

  // Steps:
  // 1. Initialize - 0%
  // 2. Login - 30%
  // 3. Submitting - 60%
  // 4. Result -  100%
  let percentage = 0;
  if (state.status === INITIALIZING) percentage = 0;
  if (state.status === UPDATING) percentage += 50;
  if (state.status === COMPLETE) percentage += 100;
  if (state.status === ERROR) percentage += 100;

  return (
    <Auth.PrivateComponent redirect="/login">
      <LayoutWithNav>
        <Row justify="space-around" align="middle" style={{ height: '50vh' }}>
          <Col span={8} xs={24} sm={20} md={12} lg={8}>
            <div style={{ textAlign: 'center' }}>
              <div>
                <Progress
                  type="circle"
                  percent={percentage}
                  status={state.status === ERROR ? 'exception' : null}
                />
              </div>
              <div style={{ marginTop: '20px' }}>
                <Text>{state.message}</Text>
              </div>
            </div>
          </Col>
        </Row>
      </LayoutWithNav>
    </Auth.PrivateComponent>
  );
}

export default Respond;
